import { Controller } from "@hotwired/stimulus"

export default class HandoffController extends Controller {
  static targets = ["userSelect", "submitButton"]

  declare userSelectTarget: HTMLSelectElement
  declare submitButtonTarget: HTMLButtonElement

  selectUser(): void {
    this.submitButtonTarget.disabled = this.userSelectTarget.value === ""
  }
}
